import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { CATEGORY_MAP } from "@/lib/data";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fileUrl = (id) => `${API}/files/${id}`;

export const lotImage = (lot) =>
  lot.photos?.length ? fileUrl(lot.photos[0]) : lot.image_url || CATEGORY_MAP[lot.category]?.image;

export const clp = (n) =>
  new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP", maximumFractionDigits: 0 }).format(n || 0);

export const num = (n, d = 1) => new Intl.NumberFormat("es-CL", { maximumFractionDigits: d }).format(n || 0);

export const errMsg = (e) => e?.response?.data?.detail?.[0]?.msg || e?.response?.data?.detail || "Ocurrió un error. Intenta de nuevo.";

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = await getToken();
      return axios({ method, url: `${API}${url}`, data, ...config, headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` } });
    },
    [getToken]
  );
}
